/* Logo-Laufband der Section "2026 Logo Treadmill" (sections/2026-logo-treadmill.liquid). */
(function() {
  if (window.vbLogoTreadmillLoaded) return;
  window.vbLogoTreadmillLoaded = true;

  function initTrack(track) {
    if (track.dataset.treadmillReady) return;
    track.dataset.treadmillReady = 'true';

    const originalItems = track.querySelectorAll('.treadmill-item');
    if (originalItems.length === 0) return;

    const CONFIG = {
      scrollSpeed: parseFloat(track.dataset.speed) || 1.5,
      pauseDuration: parseInt(track.dataset.pause) || 1500,
      logoWidth: parseInt(track.dataset.logoWidth) || 150,
      gap: parseInt(track.dataset.gap) || 30
    };

    // 2026-09-19: Die Bewegung lief über requestAnimationFrame und setzte in jedem Frame ein Inline-transform.
    // Das hielt den Main-Thread dauerhaft mit 60 Frames pro Sekunde beschäftigt (gemessen: ca. 18 % der
    // gesamten Main-Thread-Zeit der Startseite). Jetzt wird derselbe Ablauf einmal vorab durchgerechnet
    // (gleiche Logik, 60 Schritte pro Sekunde) und als Web Animation abgespielt, die der Compositor ausführt.
    // Nur das Hervorheben des mittleren Logos braucht noch einen Timer. Die Animation pausiert, solange die
    // Leiste nicht im Bild ist. Für Einstellungen, bei denen sich der Ablauf nicht sauber wiederholt (sehr enge
    // Abstände mit kurzer Pause), und für Browser ohne Web Animations läuft weiter eine Frame-Schleife.
    const FRAME_MS = 1000 / 60;
    const logoCount = originalItems.length;

    let items = Array.from(originalItems);
    let plan = null;
    let frameLoop = null;
    let introAnimation = null;
    let loopAnimation = null;
    let highlightTimer = null;
    let resizeTimer = null;
    let isVisible = false;
    let visibilityObserver = null;

    function measure() {
      const first = items[0];
      const itemWidth = first.offsetWidth;
      let step = itemWidth + (CONFIG.gap * 2);
      if (items.length > 1) step = items[1].offsetLeft - first.offsetLeft;

      return {
        viewport: window.innerWidth,
        firstLeft: track.getBoundingClientRect().left + first.offsetLeft,
        itemWidth: itemWidth,
        step: step
      };
    }

    // Rechnet den bisherigen Ablauf Frame für Frame durch: scrolling -> centering -> paused -> accelerating.
    function simulate(metrics) {
      const centerScreen = metrics.viewport / 2;
      const offFrames = Math.ceil(CONFIG.pauseDuration / FRAME_MS);
      const accelFrames = offFrames + Math.ceil(550 / FRAME_MS);
      const warmup = 4;
      const wanted = warmup + Math.max(logoCount * 6, 24);
      const maxFrames = 60 * 60 * 10;

      const positions = [0];
      const events = [];
      const accelStarts = [];
      let x = 0;
      let speed = CONFIG.scrollSpeed;
      let state = 'scrolling';
      let target = null;
      let lastActive = -1;
      let active = -1;
      let offAt = -1;
      let accelAt = -1;
      let frame = 0;

      while (accelStarts.length <= wanted && frame < maxFrames) {
        frame++;

        if (frame === offAt) {
          events.push({ frame: frame, index: active, on: false });
          active = -1;
        }
        if (frame === accelAt) {
          target = null;
          speed = 0.05;
          state = 'accelerating';
          accelStarts.push({ frame: frame, x: x });
        }

        if (state === 'scrolling') {
          x -= speed;

          let i = Math.max(0, Math.ceil((-x - metrics.firstLeft - metrics.itemWidth) / metrics.step));
          for (;; i++) {
            const left = metrics.firstLeft + (i * metrics.step) + x;
            if (left > metrics.viewport) break;
            const itemCenter = left + (metrics.itemWidth / 2);
            if (Math.abs(centerScreen - itemCenter) < CONFIG.logoWidth * 0.35) {
              if (i !== lastActive) {
                target = x - (itemCenter - centerScreen);
                state = 'centering';
                lastActive = i;
                active = i;
                events.push({ frame: frame, index: i, on: true });
                offAt = frame + offFrames;
                accelAt = frame + accelFrames;
              }
              break;
            }
          }
        }
        else if (state === 'centering') {
          const diff = target - x;
          if (Math.abs(diff) < 0.3) {
            x = target;
            state = 'paused';
          } else {
            // Sanft zur Mitte gleiten - nie schneller als aktuelle Geschwindigkeit
            x += (diff > 0 ? 1 : -1) * Math.min(Math.abs(diff) * 0.1, speed);
            speed = Math.max(speed * 0.95, 0.2);
          }
        }
        else if (state === 'accelerating') {
          if (speed < CONFIG.scrollSpeed) speed = speed + (CONFIG.scrollSpeed - speed) * 0.04;
          if (speed >= CONFIG.scrollSpeed * 0.99) {
            speed = CONFIG.scrollSpeed;
            state = 'scrolling';
          }
          x -= speed;
        }

        positions.push(x);
      }

      if (accelStarts.length <= warmup + 1) return null;

      // Die Schleife endet, sobald die Leiste um ein ganzes Vielfaches aller Logos weitergelaufen ist:
      // Ab dort wiederholen sich Inhalt und Bewegung exakt. Normal ist das ein Umlauf; bei sehr engen
      // Abständen überspringt die Beschleunigungsphase Logos, dann dauert es länger.
      const loopStart = accelStarts[warmup].frame;
      const loopWidth = logoCount * metrics.step;
      let loopEnd = -1;
      let drift = 0;
      for (let k = warmup + 1; k < accelStarts.length; k++) {
        const travelled = positions[loopStart] - positions[accelStarts[k].frame];
        const laps = Math.round(travelled / loopWidth);
        if (laps >= 1 && Math.abs(travelled - (laps * loopWidth)) <= 0.5) {
          loopEnd = accelStarts[k].frame;
          drift = travelled - (laps * loopWidth);
          break;
        }
      }
      if (loopEnd < 0) return null;

      for (let f = loopStart; f <= loopEnd; f++) {
        positions[f] += drift * ((f - loopStart) / (loopEnd - loopStart));
      }

      const toMs = (list, from) => list.map(e => ({ t: (e.frame - from) * FRAME_MS, index: e.index, on: e.on }));
      const itemsNeeded = Math.ceil((metrics.viewport - positions[loopEnd] - metrics.firstLeft) / metrics.step) + 2;
      if (itemsNeeded > Math.max(60, logoCount * 3) || loopEnd - loopStart > 60 * 180) return null;

      return {
        intro: keyframes(positions, 0, loopStart),
        loop: keyframes(positions, loopStart, loopEnd),
        introMs: loopStart * FRAME_MS,
        loopMs: (loopEnd - loopStart) * FRAME_MS,
        introEvents: toMs(events.filter(e => e.frame < loopStart), 0),
        loopEvents: toMs(events.filter(e => e.frame >= loopStart && e.frame < loopEnd), loopStart),
        itemsNeeded: itemsNeeded
      };
    }

    // Gerade Abschnitte brauchen nur zwei Stützpunkte, Kurven werden auf 0,05 px genau angenähert.
    function keyframes(positions, from, to) {
      const frames = [from];
      let a = from;
      while (a < to) {
        let b = Math.min(a + 1, to);
        while (b < to && b - a < 240) {
          const next = b + 1;
          let fits = true;
          for (let f = a + 1; f < next; f++) {
            const line = positions[a] + (positions[next] - positions[a]) * ((f - a) / (next - a));
            if (Math.abs(line - positions[f]) > 0.05) { fits = false; break; }
          }
          if (!fits) break;
          b = next;
        }
        frames.push(b);
        a = b;
      }

      return frames.map(f => ({
        offset: (f - from) / (to - from),
        transform: `translate3d(${positions[f].toFixed(2)}px, 0, 0)`
      }));
    }

    function clockMs() {
      if (loopAnimation) return plan.introMs + ((loopAnimation.currentTime || 0) % plan.loopMs);
      return Math.min((introAnimation && introAnimation.currentTime) || 0, plan.introMs);
    }

    // Setzt .is-active passend zum Stand der Animation und plant den nächsten Wechsel.
    function syncHighlight() {
      clearTimeout(highlightTimer);
      if (!plan) return;
      if (!track.isConnected) { teardown(); return; }

      const now = clockMs();
      const inLoop = !!loopAnimation;
      const list = inLoop ? plan.loopEvents : plan.introEvents;
      const offset = inLoop ? plan.introMs : 0;
      let active = -1;
      let wait = (inLoop ? plan.introMs + plan.loopMs : plan.introMs) - now;

      for (const e of list) {
        if (offset + e.t <= now) {
          active = e.on ? e.index : -1;
        } else {
          wait = offset + e.t - now;
          break;
        }
      }

      items.forEach((item, i) => item.classList.toggle('is-active', i === active));
      if (isVisible) highlightTimer = setTimeout(syncHighlight, Math.max(wait, 0) + 4);
    }

    function startLoop() {
      if (!plan || loopAnimation || !introAnimation) return;
      const startTime = introAnimation.startTime;
      loopAnimation = track.animate(plan.loop, { duration: plan.loopMs, iterations: Infinity });
      if (startTime !== null) loopAnimation.startTime = startTime + plan.introMs;
      introAnimation.cancel();
      introAnimation = null;
      if (!isVisible) loopAnimation.pause();
      syncHighlight();
    }

    function addItems(count) {
      while (items.length < count) {
        Array.from(originalItems).forEach(item => track.appendChild(item.cloneNode(true)));
        items = Array.from(track.querySelectorAll('.treadmill-item'));
      }
    }

    function build() {
      reset();
      const metrics = measure();
      plan = track.animate ? simulate(metrics) : null;

      if (!plan) {
        addItems(Math.ceil((metrics.viewport * 2.5) / metrics.step));
        frameLoop = createFrameLoop(metrics);
        return;
      }

      addItems(plan.itemsNeeded);
      track.querySelectorAll('img').forEach(img => { img.loading = 'eager'; });

      plan.viewport = metrics.viewport;
      introAnimation = track.animate(plan.intro, { duration: plan.introMs, fill: 'forwards' });
      introAnimation.onfinish = startLoop;
      syncHighlight();
    }

    function reset() {
      clearTimeout(highlightTimer);
      if (introAnimation) { introAnimation.onfinish = null; introAnimation.cancel(); }
      if (loopAnimation) loopAnimation.cancel();
      introAnimation = null;
      loopAnimation = null;
      plan = null;
      if (frameLoop) frameLoop.destroy();
      frameLoop = null;
      items.forEach(item => item.classList.remove('is-active'));
    }

    function setVisible(visible) {
      isVisible = visible;
      if (visible && !plan && !frameLoop) build();
      if (frameLoop) {
        if (visible) frameLoop.start(); else frameLoop.stop();
        return;
      }
      const animation = loopAnimation || introAnimation;
      if (animation) {
        if (visible) animation.play(); else animation.pause();
      }
      if (visible) syncHighlight(); else clearTimeout(highlightTimer);
    }

    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        if (!track.isConnected) { teardown(); return; }
        const builtFor = plan ? plan.viewport : (frameLoop ? frameLoop.viewport : window.innerWidth);
        if (builtFor !== window.innerWidth) {
          reset();
          if (isVisible) setVisible(true);
        }
      }, 200);
    }

    function onPageVisibility() {
      if (!document.hidden && isVisible) syncHighlight();
    }

    // Ersatzweg: gleiche Logik wie bisher, aber mit gerechneten statt gemessenen Positionen.
    function createFrameLoop(metrics) {
      let currentTranslate = 0;
      let appliedTranslate = 0;
      let targetTranslate = null;
      let currentSpeed = CONFIG.scrollSpeed;
      let animationFrameId = null;
      let lastActiveItem = null;
      let pauseTimeout = null;
      let accelTimeout = null;
      let state = 'scrolling'; // 'scrolling', 'centering', 'paused', 'accelerating'

      function itemLeft(index) {
        return metrics.firstLeft + (index * metrics.step) + currentTranslate;
      }

      function animate() {
        animationFrameId = null;
        if (!track.isConnected) { teardown(); return; }

        if (state === 'scrolling') {
          currentTranslate -= currentSpeed;
          checkCenter();
        }
        else if (state === 'centering') {
          const diff = targetTranslate - currentTranslate;

          if (Math.abs(diff) < 0.3) {
            currentTranslate = targetTranslate;
            state = 'paused';
          } else {
            // Sanft zur Mitte gleiten - nie schneller als aktuelle Geschwindigkeit
            const step = Math.min(Math.abs(diff) * 0.1, currentSpeed);
            currentTranslate += (diff > 0 ? 1 : -1) * step;
            currentSpeed = Math.max(currentSpeed * 0.95, 0.2);
          }
        }
        else if (state === 'accelerating') {
          if (currentSpeed < CONFIG.scrollSpeed) {
            currentSpeed = currentSpeed + (CONFIG.scrollSpeed - currentSpeed) * 0.04;
          }
          if (currentSpeed >= CONFIG.scrollSpeed * 0.99) {
            currentSpeed = CONFIG.scrollSpeed;
            state = 'scrolling';
          }
          currentTranslate -= currentSpeed;
        }

        // Infinite scroll logic
        if (state === 'scrolling' && itemLeft(0) + metrics.itemWidth < 0) {
          track.appendChild(items[0]);
          items.push(items.shift());
          currentTranslate += metrics.step;
        }

        if (currentTranslate !== appliedTranslate) {
          track.style.transform = `translate3d(${currentTranslate}px, 0, 0)`;
          appliedTranslate = currentTranslate;
        }

        animationFrameId = requestAnimationFrame(animate);
      }

      function checkCenter() {
        const centerScreen = metrics.viewport / 2;

        for (let i = 0; i < items.length; i++) {
          const left = itemLeft(i);
          if (left + metrics.itemWidth < 0) continue;
          if (left > metrics.viewport) break;

          const itemCenter = left + (metrics.itemWidth / 2);
          if (Math.abs(centerScreen - itemCenter) < CONFIG.logoWidth * 0.35) {
            if (items[i] !== lastActiveItem) {
              triggerPause(items[i], itemCenter, centerScreen);
              lastActiveItem = items[i];
            }
            break;
          }
        }
      }

      function triggerPause(item, itemCenter, centerScreen) {
        targetTranslate = currentTranslate - (itemCenter - centerScreen);
        state = 'centering';
        item.classList.add('is-active');

        clearTimeout(pauseTimeout);
        pauseTimeout = setTimeout(() => {
          item.classList.remove('is-active');

          // Warten bis Scale-Transition fertig ist, dann sanft beschleunigen
          accelTimeout = setTimeout(() => {
            targetTranslate = null;
            currentSpeed = 0.05;
            state = 'accelerating';
          }, 550);
        }, CONFIG.pauseDuration);
      }

      function stop() {
        if (animationFrameId !== null) cancelAnimationFrame(animationFrameId);
        animationFrameId = null;
      }

      return {
        viewport: metrics.viewport,
        start: function() {
          if (animationFrameId === null) animationFrameId = requestAnimationFrame(animate);
        },
        stop: stop,
        destroy: function() {
          stop();
          clearTimeout(pauseTimeout);
          clearTimeout(accelTimeout);
          track.style.transform = '';
        }
      };
    }

    function teardown() {
      reset();
      if (visibilityObserver) visibilityObserver.disconnect();
      window.removeEventListener('resize', onResize);
      document.removeEventListener('visibilitychange', onPageVisibility);
    }

    window.addEventListener('resize', onResize);
    document.addEventListener('visibilitychange', onPageVisibility);

    if ('IntersectionObserver' in window) {
      visibilityObserver = new IntersectionObserver(entries => {
        setVisible(entries[entries.length - 1].isIntersecting);
      });
      visibilityObserver.observe(track.parentElement);
    } else {
      setVisible(true);
    }
  }

  function initAll(root) {
    root.querySelectorAll('.treadmill-track').forEach(initTrack);
  }

  initAll(document);
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();
